export default "__VITE_ASSET__DJwldsgP__"